class PopupLogin {
	constructor() {
		const item = document.getElementById('login-item');
		const closeBtn = document.querySelector('#loginPopup .popup-close');
		const popup = document.getElementById('loginPopup');

		if (item != undefined || item !== null) {
			item.addEventListener('click', () => {
				this.show(popup);
			});
		}

		if (closeBtn != undefined || closeBtn !== null) {
			closeBtn.addEventListener('click', () => {
				this.close(popup);
			});
		}

		if (popup != undefined || popup !== null) {
			popup.addEventListener('click', e => {
				if (e.target === e.currentTarget) {
					this.close(e.target);
				}
			});
		}
	}

	show(popup) {
		popup.classList.remove('d-none');
	}

	close(popup) {
		popup.classList.add('d-none');
	}
}

export default PopupLogin;
